module.exports = __webpack_public_path__ + "img/第三期.7302bd3e.png";